import React from 'react';
import { Translate } from 'react-redux-i18n';
import LinkButtonView from '../buttons/link';
import OverlayMessage from '../overlayMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const PageNotFoundView = () => /*#__PURE__*/_jsx(OverlayMessage, {
  type: "error",
  message: /*#__PURE__*/_jsx(Translate, {
    value: "message.pageNotFound"
  }),
  children: /*#__PURE__*/_jsx(LinkButtonView, {
    link: "/",
    buttonLabel: /*#__PURE__*/_jsx(Translate, {
      value: "action.returnToHome"
    })
  })
});
export default PageNotFoundView;